import React, { Fragment } from 'react';
import { Link } from 'react-router-dom'
import Header6 from '../../components/header6/Header6';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/Help-Desk-Components/Footer/Footer';

const GDPRPage = () => {
    return (
        <Fragment>
            <div className='help_desk'>
                <Header6 />

                {/* Page Header */}
                <section style={{
                    background: 'linear-gradient(135deg, #4b5563 0%, #374151 50%, #1f2937 100%)',
                    paddingTop: '140px',
                    paddingBottom: '80px',
                    position: 'relative',
                    overflow: 'hidden'
                }}>
                    {/* Decorative elements */}
                    <div style={{
                        position: 'absolute',
                        top: '-100px',
                        right: '-100px',
                        width: '300px',
                        height: '300px',
                        background: 'radial-gradient(circle, rgba(59, 130, 246, 0.1) 0%, transparent 70%)',
                        borderRadius: '50%',
                        pointerEvents: 'none'
                    }}></div>

                    <div className="container">
                        <div style={{ maxWidth: '800px' }}>
                            <span className="section-badge" style={{
                                background: 'rgba(59, 130, 246, 0.15)',
                                borderColor: 'rgba(59, 130, 246, 0.3)',
                                color: '#93c5fd',
                                marginBottom: '20px',
                                display: 'inline-flex'
                            }}>
                                Legal
                            </span>
                            <h1 style={{
                                fontSize: '3rem',
                                fontWeight: '800',
                                color: 'white',
                                marginBottom: '16px',
                                lineHeight: '1.2'
                            }}>
                                GDPR Compliance
                            </h1>
                            <p style={{
                                fontSize: '1.125rem',
                                color: 'rgba(255, 255, 255, 0.7)',
                                marginBottom: '8px'
                            }}>
                                Our commitment to protecting your data under the General Data Protection Regulation.
                            </p>
                            <span style={{
                                fontSize: '0.875rem',
                                color: 'rgba(255, 255, 255, 0.5)'
                            }}>
                                Last updated: February 2nd, 2026
                            </span>
                        </div>
                    </div>
                </section>

                {/* Content Section */}
                <section style={{
                    background: '#ffffff',
                    padding: '80px 0'
                }}>
                    <div className="container">
                        <div style={{ maxWidth: '800px', margin: '0 auto' }}>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>Introduction</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8', marginBottom: '16px' }}>
                                    SaaS Watch is committed to protecting the privacy and security of personal data in compliance with the General Data Protection Regulation (GDPR). This page outlines how we collect, process, store, and protect personal data of individuals within the European Economic Area (EEA).
                                </p>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    The GDPR provides individuals with greater control over their personal data and imposes strict requirements on organizations that process such data. We take these obligations seriously and have implemented appropriate measures to ensure compliance.
                                </p>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>Data Controller</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    SaaS Watch acts as the Data Controller for personal data collected through our website and services. As the Data Controller, we determine the purposes and means of processing personal data and are responsible for ensuring compliance with data protection laws.
                                </p>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>Lawful Basis for Processing</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8', marginBottom: '16px' }}>
                                    Under the GDPR, we process personal data only when we have a lawful basis to do so. The lawful bases we rely on include:
                                </p>
                                <ul style={{
                                    listStyle: 'none',
                                    padding: 0,
                                    margin: 0
                                }}>
                                    {[
                                        { title: 'Consent', desc: 'Where you have given clear consent for us to process your personal data for a specific purpose.' },
                                        { title: 'Contract', desc: 'Where processing is necessary for the performance of a contract with you or to take steps at your request before entering into a contract.' },
                                        { title: 'Legal Obligation', desc: 'Where processing is necessary for compliance with a legal obligation to which we are subject.' },
                                        { title: 'Legitimate Interests', desc: 'Where processing is necessary for our legitimate interests or the legitimate interests of a third party, provided your rights do not override those interests.' }
                                    ].map((item, index) => (
                                        <li key={index} style={{
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: '12px',
                                            marginBottom: '16px',
                                            color: '#4b5563'
                                        }}>
                                            <span style={{
                                                width: '24px',
                                                height: '24px',
                                                background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flexShrink: 0,
                                                marginTop: '2px',
                                                color: 'white',
                                                fontSize: '12px',
                                                fontWeight: '600'
                                            }}>
                                                {index + 1}
                                            </span>
                                            <div>
                                                <strong style={{ color: '#1f2937' }}>{item.title}:</strong> {item.desc}
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>Your Rights Under GDPR</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8', marginBottom: '16px' }}>
                                    The GDPR provides you with the following rights regarding your personal data:
                                </p>
                                <ul style={{
                                    listStyle: 'none',
                                    padding: 0,
                                    margin: 0
                                }}>
                                    {[
                                        { title: 'Right to Access', desc: 'You have the right to request a copy of the personal data we hold about you.' },
                                        { title: 'Right to Rectification', desc: 'You have the right to request that we correct any inaccurate or incomplete personal data.' },
                                        { title: 'Right to Erasure', desc: 'You have the right to request that we delete your personal data in certain circumstances ("right to be forgotten").' },
                                        { title: 'Right to Restrict Processing', desc: 'You have the right to request that we limit the processing of your personal data in certain circumstances.' },
                                        { title: 'Right to Data Portability', desc: 'You have the right to receive your personal data in a structured, commonly used, machine-readable format.' },
                                        { title: 'Right to Object', desc: 'You have the right to object to the processing of your personal data in certain circumstances.' },
                                        { title: 'Rights Related to Automated Decision-Making', desc: 'You have the right not to be subject to decisions based solely on automated processing, including profiling.' }
                                    ].map((item, index) => (
                                        <li key={index} style={{
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: '12px',
                                            marginBottom: '16px',
                                            color: '#4b5563'
                                        }}>
                                            <span style={{
                                                width: '20px',
                                                height: '20px',
                                                background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flexShrink: 0,
                                                marginTop: '2px'
                                            }}>
                                                <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                                                    <path d="M1 4L3.5 6.5L9 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </span>
                                            <div>
                                                <strong style={{ color: '#1f2937' }}>{item.title}:</strong> {item.desc}
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>Data We Collect</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8', marginBottom: '16px' }}>
                                    We may collect and process the following categories of personal data:
                                </p>
                                <ul style={{ color: '#4b5563', lineHeight: '1.8', paddingLeft: '24px' }}>
                                    <li style={{ marginBottom: '8px' }}>Identity data (name, username, or similar identifier)</li>
                                    <li style={{ marginBottom: '8px' }}>Contact data (email address, telephone number, address)</li>
                                    <li style={{ marginBottom: '8px' }}>Technical data (IP address, browser type, device information)</li>
                                    <li style={{ marginBottom: '8px' }}>Usage data (information about how you use our website and services)</li>
                                    <li style={{ marginBottom: '8px' }}>Marketing and communications data (your preferences for receiving marketing)</li>
                                </ul>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>Data Security</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8', marginBottom: '16px' }}>
                                    We have implemented appropriate technical and organizational measures to protect personal data against unauthorized access, alteration, disclosure, or destruction. These measures include:
                                </p>
                                <ul style={{ color: '#4b5563', lineHeight: '1.8', paddingLeft: '24px' }}>
                                    <li style={{ marginBottom: '8px' }}>Encryption of data in transit and at rest</li>
                                    <li style={{ marginBottom: '8px' }}>Regular security assessments and audits</li>
                                    <li style={{ marginBottom: '8px' }}>Access controls and authentication mechanisms</li>
                                    <li style={{ marginBottom: '8px' }}>Employee training on data protection</li>
                                    <li style={{ marginBottom: '8px' }}>Incident response procedures</li>
                                </ul>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>International Data Transfers</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    When we transfer personal data outside the EEA, we ensure that appropriate safeguards are in place to protect your data. These safeguards may include Standard Contractual Clauses approved by the European Commission, or transfers to countries that have been deemed to provide an adequate level of data protection.
                                </p>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>Data Retention</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    We retain personal data only for as long as necessary to fulfill the purposes for which it was collected, including to satisfy legal, accounting, or reporting requirements. When personal data is no longer needed, we securely delete or anonymize it.
                                </p>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>Cookies and Tracking</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    Our website uses cookies and similar tracking technologies. We obtain your consent before placing non-essential cookies on your device. You can manage your cookie preferences at any time through your browser settings or our cookie consent tool. For more information, please see our <Link to="/privacy-policy" style={{ color: '#3b82f6', textDecoration: 'underline' }}>Privacy Policy</Link>.
                                </p>
                            </div>

                            <div style={{ marginBottom: '48px' }}>
                                <h2 style={{
                                    fontSize: '1.5rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '16px'
                                }}>Data Breach Notification</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    In the event of a personal data breach that is likely to result in a risk to your rights and freedoms, we will notify the relevant supervisory authority within 72 hours of becoming aware of the breach. If the breach is likely to result in a high risk to your rights and freedoms, we will also notify you directly.
                                </p>
                            </div>

                            <div style={{
                                background: '#f3f4f6',
                                borderRadius: '16px',
                                padding: '32px',
                                marginTop: '48px'
                            }}>
                                <h2 style={{
                                    fontSize: '1.25rem',
                                    fontWeight: '700',
                                    color: '#1f2937',
                                    marginBottom: '12px'
                                }}>Exercise Your Rights</h2>
                                <p style={{ color: '#4b5563', lineHeight: '1.8', marginBottom: '16px' }}>
                                    To exercise any of your GDPR rights or if you have questions about how we handle your personal data, please <Link to="/#contact" style={{ color: '#3b82f6', textDecoration: 'underline' }}>contact us</Link>.
                                </p>
                                <p style={{ color: '#4b5563', lineHeight: '1.8' }}>
                                    You also have the right to lodge a complaint with a supervisory authority if you believe that your data protection rights have been violated.
                                </p>
                            </div>

                        </div>
                    </div>
                </section>

                <Scrollbar />
            </div>
            <Footer />
        </Fragment>
    )
};

export default GDPRPage;
